import {usrPermission} from "./userPermission";

export const apiMenu:any = [
    {
        label: "Dashboards",
        icon: "pi pi-home",
        items: [
            {
                label: "Home",
                icon: "pi pi-fw pi-home",
                to: "/",
                permission: usrPermission.home.r,
            },
            {
                label: "About Event",
                icon: "pi pi-calendar-clock",
                to: "/about-event",
                permission: usrPermission.event.r,
            },
            {
                label: "Exhibitors",
                icon: "pi pi-fw pi-briefcase",
                to: "/exhibitors",
                permission: usrPermission.exhibitors.r,
            },
            {
                label: "Guest & Speakers",
                icon: "fa-solid fa-microphone-lines",
                to: "/guest-speakers",
                permission: usrPermission.guestSpeakers.r,
            },
            {
                label: "Partner & Sponsors",
                icon: "pi pi-star",
                to: "/partner-and-sponsors",
                permission: usrPermission.partners.r,
            },
            {
                label: "Designer",
                icon: "fa-solid  fa-object-group",
                to: "/gallery",
                permission: usrPermission.designer.r,
            },
            {
                label: "Messages",
                icon: "pi pi-fw pi-envelope",
                to: "/message",
                permission: usrPermission.message.r,
            },{
            label: "Site Info",
            icon: "pi pi-fw pi-info-circle",
            to: "/site-info",
            permission: usrPermission.siteInfo.r,
            }
        ],
    },
];